import { Popover, Typography, Alert } from '@mui/material'
import { CvsAvatar, DarkButton, Paper } from '@components'
import { useCommentsContext } from '@templates/approval/contexts'
import { ActionType } from '@templates/approval/contexts/commentsContext/types'
import * as css from './styles'
import { t } from '@lingui/core/macro'

interface Props {
  anchorEl: Element | (() => Element) | null | undefined
  cvId: string
  fieldId: number
  open: boolean
  rowIdx: number
  handlePopoverClose: (event: unknown) => void
}

export const CommentPopover = ({
  anchorEl,
  cvId,
  fieldId,
  open,
  rowIdx,
  handlePopoverClose,
}: Props) => {
  const classes = css.usePopoverStyles()
  const { dispatch, comments, removeComment } = useCommentsContext()

  if (!comments[cvId]?.[fieldId]) {
    return null
  }

  const { commenter, message } = comments[cvId][fieldId]

  return (
    <Popover
      open={open}
      className={classes.popover}
      classes={{
        paper: classes.popoverContent,
      }}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      onClose={handlePopoverClose}
      disableRestoreFocus
    >
      <Paper css={css.paper}>
        <Alert variant="outlined" severity="error">
          Value rejected during approval
        </Alert>
        <css.CommentContainer>
          <CvsAvatar user={commenter} />
          <css.Message>
            <Typography variant="body1" css={[css.bold, css.smallerFont]}>
              {commenter.name} {t`left a comment...`}
            </Typography>
            <Typography variant="body1" css={css.smallerFont}>
              {message}
            </Typography>
          </css.Message>
        </css.CommentContainer>
        <css.ButtonContainer>
          <DarkButton onClick={handleEditComment} css={css.editButton}>
            {t`Edit`}
          </DarkButton>
          <DarkButton onClick={handleRemoveComment}>{t`Remove`}</DarkButton>
        </css.ButtonContainer>
      </Paper>
    </Popover>
  )

  function handleEditComment() {
    dispatch({
      type: ActionType.setCommentDialogOpen,
      payload: true,
    })

    dispatch({
      type: ActionType.setCurrentCommentDetails,
      payload: {
        cvId,
        rowIdx,
        fieldId,
        commenter,
      },
    })
  }

  function handleRemoveComment() {
    removeComment({
      cvId,
      fieldId,
      rowIdx,
    })

    dispatch({
      type: ActionType.setCurrentCommentDetails,
      payload: null,
    })
  }
}
